import React from 'react';
import rotateVid from '../images/rotateVid.gif';
import styles from '../styles/rotatedevice.module.css';

const RotateDevice = () => {
    return (
    <>
        <div className={styles.rotateContainer}>
            <div className={styles.gifContainer}>
                <img className={styles.rotateVid} src={rotateVid} alt="rotateVid" />
            </div>
            <div className={styles.textContainer}>
                <p>For Best Experience -</p>
                <p>Please Rotate Device To Portrait</p>
            </div>
        </div>
    </>
    );
  };
  
export default RotateDevice;